export const DISCLOSURE_BANNER_PXS = 46;
export const PORTION_OF_NEXT_BANNER_PXS = 10;
export const TOP_PORTION_OF_LARGE_BANNER_PXS = 35;
